var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { attrs: { id: "scd_schedule-logo" } }, [
        false
          ? _c("img", {
              staticStyle: { "max-height": "30px" },
              attrs: {
                src: require("@/assets/images/logo/logo.png"),
                alt: "Securamdata"
              }
            })
          : _vm._e()
      ]),
      _c("b-img", {
        attrs: {
          fluid: "",
          id: "scd_schedule-img",
          src: require("@/assets/images/pages/calendar-illustration.png")
        }
      }),
      _vm.hash
        ? _c(
            "div",
            { attrs: { id: "scd_schedule-confirmation" } },
            [
              _c(
                "b-card",
                {
                  staticClass: "h-full",
                  attrs: { "header-bg-variant": "primary" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "header",
                        fn: function() {
                          return [
                            _c(
                              "span",
                              { staticClass: "text-white text-lg font-bold" },
                              [_vm._v("SECURAMDATA - Confirmar Agenda")]
                            )
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "footer",
                        fn: function() {
                          return [
                            _c(
                              "div",
                              { staticClass: "flex flex-row justify-end" },
                              [
                                _vm.hasEvent
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              disabled: _vm.eventRejected,
                                              variant: "danger"
                                            },
                                            on: { click: _vm.rejectAll }
                                          },
                                          [_vm._v("Rejeitar Sugestões")]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _c("page-footer")
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    1984478103
                  )
                },
                [
                  _c("div", { staticClass: "pt-1" }, [
                    _c("div", { staticClass: "flex flex-col gap-1" }, [
                      _c("div", { staticClass: "_row" }, [
                        _c("span", [
                          _vm._v("Prezado(a) "),
                          _vm.activeGuestName
                            ? _c("span", { staticClass: "text-primary" }, [
                                _vm._v(_vm._s(_vm.activeGuestName))
                              ])
                            : _vm._e(),
                          _vm.activeGuestEmail
                            ? _c("span", { staticClass: "text-primary" }, [
                                _vm._v(
                                  _vm._s(" <" + _vm.activeGuestEmail + ">")
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" , ")
                        ])
                      ]),
                      _vm.eventTitle
                        ? _c("div", { staticClass: "_row" }, [
                            _c("span", [
                              _vm._v(
                                "Você foi convidado(a) para " +
                                  _vm._s(_vm.eventTypeLabel) +
                                  ": "
                              ),
                              _c("span", { staticClass: "text-primary" }, [
                                _vm._v(_vm._s(_vm.eventTitle))
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "_row" }, [
                        _c("span", [
                          _c("b", [_vm._v("Agendado por:")]),
                          _vm._v(" " + _vm._s(_vm.eventAuthor) + " ")
                        ])
                      ]),
                      _c("div", { staticClass: "_row" }, [
                        _vm.hasEvent
                          ? _c("span", [
                              _c("b", [_vm._v("Local:")]),
                              _vm._v(' "Esta é uma conferência online." ')
                            ])
                          : _vm._e()
                      ]),
                      _vm.eventUrl
                        ? _c("div", { staticClass: "_row" }, [
                            _c("span", [
                              _c("b", [_vm._v("Onde:")]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    target: "_blank",
                                    href: _vm.eventUrl
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.$t("click_here")))
                                  ]),
                                  _vm._v(
                                    " para acessar à reunião com a Santa Cruz Consultoria Jurídica e Advocacia"
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm.eventDescription
                        ? _c("div", { staticClass: "_row" }, [
                            _c("b", [_vm._v("Descrição:")])
                          ])
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "_row",
                          staticStyle: { "padding-left": "2rem" }
                        },
                        [
                          _c("div", {
                            directives: [
                              {
                                name: "html-safe",
                                rawName: "v-html-safe",
                                value: _vm.eventDescription,
                                expression: "eventDescription"
                              }
                            ],
                            staticClass: "simple-content simple-editor"
                          })
                        ]
                      ),
                      _vm.hasEventAttachments
                        ? _c("div", { staticClass: "_row" }, [
                            _c("b", [_vm._v("Anexos:")])
                          ])
                        : _vm._e(),
                      _vm.hasEventAttachments
                        ? _c(
                            "div",
                            { staticClass: "_row" },
                            [
                              _c("media-list", {
                                attrs: {
                                  "show-delete": false,
                                  medias: _vm.event.attachments
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]),
                    _c(
                      "div",
                      { staticClass: "pt-2" },
                      [
                        _c("b-table", {
                          attrs: {
                            items: _vm.eventSuggestions,
                            fields: _vm.getSuggestionsTableFields()
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "cell(situation)",
                                fn: function(ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      "span",
                                      {
                                        class: [
                                          {
                                            REJ: "text-danger",
                                            CON: "text-success",
                                            CONREJ: "text-purple",
                                            PEN: _vm.hasAnyConfirmedSuggestion
                                              ? "opacity-50"
                                              : "text-warning"
                                          }[item.situation]
                                        ]
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "schedule_guest.situation." +
                                                  item.situation
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              },
                              {
                                key: "cell(start_at)",
                                fn: function(ref) {
                                  var start_at = ref.item.start_at
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.formatDate(start_at)))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "cell(finish_at)",
                                fn: function(ref) {
                                  var finish_at = ref.item.finish_at
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.formatDate(finish_at)))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "cell(action)",
                                fn: function(ref) {
                                  var item = ref.item
                                  return [
                                    _vm.withinDate(
                                      item.start_at,
                                      item.finish_at
                                    )
                                      ? [
                                          !item.rejected
                                            ? [
                                                !item.scheduled &&
                                                !_vm.hasAnyConfirmedSuggestion
                                                  ? _c(
                                                      "b-button",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "ripple",
                                                            rawName:
                                                              "v-ripple.400",
                                                            value:
                                                              "rgba(40, 199, 111, 0.15)",
                                                            expression:
                                                              "'rgba(40, 199, 111, 0.15)'",
                                                            modifiers: {
                                                              "400": true
                                                            }
                                                          }
                                                        ],
                                                        attrs: {
                                                          variant:
                                                            "flat-success"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.confirmSchedule(
                                                              item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("feather-icon", {
                                                          staticClass: "mr-50",
                                                          attrs: {
                                                            icon: "CheckIcon"
                                                          }
                                                        }),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "align-middle"
                                                          },
                                                          [_vm._v("Confirmar")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                !item.rejected && item.scheduled
                                                  ? _c(
                                                      "b-button",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "ripple",
                                                            rawName:
                                                              "v-ripple.400",
                                                            value:
                                                              "rgba(40, 199, 111, 0.15)",
                                                            expression:
                                                              "'rgba(40, 199, 111, 0.15)'",
                                                            modifiers: {
                                                              "400": true
                                                            }
                                                          }
                                                        ],
                                                        attrs: {
                                                          variant:
                                                            "flat-warning"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.rejectSchedule(
                                                              item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("feather-icon", {
                                                          staticClass: "mr-50",
                                                          attrs: {
                                                            icon: "XCircleIcon"
                                                          }
                                                        }),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "align-middle"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.scheduled
                                                                  ? "Desmarcar"
                                                                  : "Rejeitar"
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            : [
                                                _c(
                                                  "b-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "ripple",
                                                        rawName: "v-ripple.400",
                                                        value:
                                                          "rgba(40, 199, 111, 0.15)",
                                                        expression:
                                                          "'rgba(40, 199, 111, 0.15)'",
                                                        modifiers: {
                                                          "400": true
                                                        }
                                                      }
                                                    ],
                                                    attrs: {
                                                      disabled: "",
                                                      variant: "flat-warning"
                                                    }
                                                  },
                                                  [
                                                    _c("feather-icon", {
                                                      staticClass: "mr-50",
                                                      attrs: {
                                                        icon: "XCircleIcon"
                                                      }
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "align-middle"
                                                      },
                                                      [_vm._v("Rejeitado")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                        ]
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            538826736
                          )
                        })
                      ],
                      1
                    )
                  ])
                ]
              ),
              _c(
                "vs-popup",
                {
                  attrs: {
                    title: "Confirmar Rejeição de Agenda",
                    active: _vm.showRejectionPopup
                  },
                  on: {
                    "update:active": function($event) {
                      _vm.showRejectionPopup = $event
                    }
                  }
                },
                [
                  !_vm.rejectingAll && _vm.rejectingSuggestionData
                    ? _c("div", { staticClass: "w-full pb-2" }, [
                        _vm._v(" " + _vm._s(_vm.rejectingSuggestionData) + " ")
                      ])
                    : _vm._e(),
                  _c("b-form-textarea", {
                    attrs: {
                      id: "textarea",
                      placeholder: _vm.rejectingAll
                        ? "Justifique o motive de não poder participar de nenhum horário"
                        : "Justifique o motivo de não poder participar neste horário.",
                      rows: "4",
                      "max-rows": "6"
                    },
                    model: {
                      value: _vm.justification,
                      callback: function($$v) {
                        _vm.justification = $$v
                      },
                      expression: "justification"
                    }
                  }),
                  _c(
                    "div",
                    { staticClass: "flex justify-end pt-2" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            disabled: !_vm.justification,
                            variant: "primary"
                          },
                          on: {
                            click: function() {
                              return _vm.confirmRejection(_vm.justification)
                            }
                          }
                        },
                        [_vm._v("Confirmar")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }